import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../../common/theme/ISpcTheme';

export type FeaturesDetailListClasses = 'title';

const featuresDetailListStyles = makeStyles<ISpcTheme, FeaturesDetailListClasses>(
  theme => ({
    title: {
      fontSize: theme.typography.fontLG,
      fontFamily: theme.typography.fontFamily2,
      padding: '10px 0',
    },
  }),
  { name: 'Customise_FeaturesDetailListStyles' },
);

export default featuresDetailListStyles;
